import { Grid, Menu } from '@material-ui/core';
import React, { useState, useEffect, useContext } from 'react';
import useSWR from 'swr';
import { AppContext } from 'Context';

import { dataFetcher, endpoints } from 'Api';
import styles from './index.module.css';

export default function CardDetails({ handleUpdateCard, card, paymentMethods, brand, last4, status, isPreferred, cardId, removedAllowed, expMonth, expyear }) {
  const { setAppSnackbar, subscriptionDetails, getSubscription, langText, cardUpdate, setcardUpdate } = useContext(AppContext);
  const paymentMethodText = langText?.settings?.billPayment?.paymentMethod;
  const commonText = langText?.common;
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const currentDate = new Date(); // System's local time
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // Months are 0-based
  const isExpired = expyear < currentYear
                  || (expyear === currentYear && expMonth < currentMonth);

  const { isValidating: removingCard, mutate: removeCard } = useSWR([endpoints.removePaymentMethods, cardId], {
    fetcher: (url, cardId) => dataFetcher(url, { payment_method_id: cardId }),
    onSuccess: ({ success }) => {
      if (success) {
        getSubscription();
        setMobileMoreAnchorEl(null);
        setAppSnackbar({
          isVisible: true, type: 'success', message: 'Removed Successfully' });
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong while removing',
        });
      }
    },
    onError: () => {
      setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while removing' });
    },
  });
  const { isValidating: makingDefault, mutate: makeDefault } = useSWR([endpoints.setDefaultPaymentMethods, cardId], {
    fetcher: (url, cardId) => dataFetcher(url, { payment_method_id: cardId }),
    onSuccess: ({ success }) => {
      if (success) {
        getSubscription();
        setAppSnackbar({
          isVisible: true, type: 'success', message: 'Set Default payment method Successfully' });
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong while setting default payment method',
        });
      }
    },
    onError: () => {
      setAppSnackbar({ isVisible: true,
        type: 'error',
        message: 'Oops! Something went wrong while setting default payment method' });
    },
  });

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMobileMenuOpen = (event, id) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
  const handleRemoveCard = () => {
    if (removedAllowed) {
      removeCard();
    } else {
      setAppSnackbar({ isVisible: true,
        type: 'error',
        message: 'To remove this card you have to add one more payment method' });
    }
  };
  const handlePreferredCard = () => {
    makeDefault();
  };
  const startDate = new Date(subscriptionDetails?.subscription?.start_date);
  const endDate = new Date(subscriptionDetails?.subscription?.end_date);
  const trialDuration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)); // Calculate duration in days
  // Ensure totalTrialDays is correctly converted to a number

  const totalTrialDays = parseInt(subscriptionDetails?.subscription?.total_trial_days, 10);
  const shouldShowRemoveButton = !(paymentMethods.length === 1 && trialDuration === totalTrialDays);
  const expYear = card?.exp_year;
  const expYearForCARD = expYear?.toString();
  const expiMonth = card?.exp_month;
  const shortYear = expYearForCARD?.slice(2, 4);
// eslint-disable-next-line
useEffect(() => {
  setcardUpdate((expYear < currentYear) || (expYear === currentYear && expiMonth <= currentMonth));
  // setcardUpdate((currentYear > 2024) || (currentYear === 2024 && currentMonth >= 11));
}, [card]);
  return (
    <div className={styles.cardDetails}>

      <div className={`${styles.labelLinks} ${styles.secondLabelLink} `}>
        <div className={`${styles.label} ${styles.secondLabel} `}>
          {brand}
          {last4
               && (
                <div>
               <span className={`${styles.colorBlack} `}>
                 {' '}
                 ***** ****
                 {' '}
                 {last4}
                 <br />
{card?.exp_month}
/
{shortYear}
               </span>
              {isExpired && (
                <p className={styles.redColorExpired}>Card Expired</p>
              )}
               {status?.payment_status === '0' && (
                <div className={styles.redColorExpired}>
                {`(${status?.failure_reason || 'Expired'})`}
                </div>
                )}
                </div>
               )}
        </div>
        {isPreferred && <div className={styles.preferred}>{paymentMethodText?.preferred || 'PREFERRED'}</div>}
        <Grid
          onClick={(event) => { cardUpdate ? handleUpdateCard(card, cardId) : handleMobileMenuOpen(event); }}
          className={`${styles.link} ${styles.secondLink} `}
        >
      {cardUpdate === false ? commonText?.edit || 'Edit' : 'Update'}

        </Grid>
        <Menu
          anchorEl={mobileMoreAnchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          // keepMounted
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isMobileMenuOpen}
          onClose={handleMobileMenuClose}
          PopoverClasses={{ paper: styles.dropDownAnimation }}
        >
          <div
            className={`${styles.editButtonsMenu}`}
          >
            <button
              // style={{ display: `${isPreferred ? 'none' : undefined}` }}
              disabled={isPreferred}
              onClick={handlePreferredCard}
              className={`${styles.editButton}`}
            >
              {!isPreferred && makingDefault ? (paymentMethodText?.markingPreffered || 'Making preferred') : (paymentMethodText?.markPreffered || 'Mark Preferred')}
            </button>
            {subscriptionDetails?.subscription?.is_trial !== '1' && (
            <button
            onClick={handleRemoveCard}
        // onClick={() => deleteThis(groupType, currentId)}
            className={`${styles.editButton}`}
            >
            {removingCard ? (paymentMethodText?.removingCard || 'Removing Card') : (paymentMethodText?.removeCard || 'Remove Card')}
            </button>
            )}
          </div>

        </Menu>
      </div>

    </div>
  );
}
